import { render, staticRenderFns } from "./OrderCartLogos.vue?vue&type=template&id=4fad0f2a&"
import script from "./OrderCartLogos.vue?vue&type=script&lang=js&"
export * from "./OrderCartLogos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports